import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { useField } from 'formik';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { loadShippingTypes } from '@sophocles/features/warehouse/orders/api';
import { shippingTypeSlice } from '@sophocles/features/warehouse/orders/slice';

function ShippingTypeSelect({
  label,
  name,
  size,
  fullWidth = false,
  value,
  onChange,
  error,
  helperText,
  disabled = false,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const resolvedLabel = label ?? t('warehouse.shippingType', 'Shipping Type');
  const shippingTypes = useSelector(state => shippingTypeSlice.selectors.selectAllEntities(state));

  useEffect(() => {
    // load if no shipping types
    if (shippingTypes.length === 0) {
      dispatch(loadShippingTypes());
    }
  }, [shippingTypes]);

  return (
    <FormControl
      disabled={disabled}
      fullWidth={fullWidth ?? false}
      size={size ?? 'small'}
      sx={{ maxWidth: 400 }}
      error={error}
    >
      <InputLabel id="shipping-type-select-label">{resolvedLabel}</InputLabel>
      <Select
        labelId="shipping-type-select-label"
        label={resolvedLabel}
        id="shipping-type-select"
        name={name}
        size="small"
        value={value}
        onChange={onChange}
        fullWidth
        disabled={disabled}
        error={error}
      >
        {shippingTypes.map(shippingType => (
          <MenuItem key={shippingType.id} value={shippingType.id}>
            {shippingType.name}
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText color="error">{helperText}</FormHelperText>}
    </FormControl>
  );
}

function FormikShippingTypeSelect({ name, error, helperText, ...props }) {
  const [field, meta, helpers] = useField(name);

  const handleChange = event => {
    helpers.setValue(event.target.value);
    if (props.onChange) {
      props.onChange(event);
    }
  };

  return (
    <ShippingTypeSelect
      name={name}
      value={field.value}
      onChange={handleChange}
      error={error}
      helperText={helperText}
      {...props}
    />
  );
}

export { FormikShippingTypeSelect };

export default ShippingTypeSelect;
